<template>
    <syuugyou-kisoku-list />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import List from '@/components/syuugyoukisoku/List.vue';

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'syuugyou-kisoku-list': List
    }
})
</script>
